 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK1COVER from '@/components/Book1/cover'
 import BOOK1LEHMANN_BALLADSOURCE_3P_MD from '@/components/Book1/Lehmann_BalladSource_3P_MD'
 import BOOK1LEHMANN_BALLADSOURCE_3P_MD2 from '@/components/Book1/Lehmann_BalladSource_3P_MD2'
 import BOOK1LEHMANN_BALLADSOURCE_3P_MD9 from '@/components/Book1/Lehmann_BalladSource_3P_MD9'
 import BOOK1LEHMANN_BALLADSOURCE_3P_MD10 from '@/components/Book1/Lehmann_BalladSource_3P_MD10'
 import BOOK1LEHMANN_BALLADSOURCE_3P_MD11 from '@/components/Book1/Lehmann_BalladSource_3P_MD11'
 import BOOK1LEHMANN_BALLADSOURCE_3P_MD12 from '@/components/Book1/Lehmann_BalladSource_3P_MD12'
 import BOOK2COVER from '@/components/Book2/cover'
 import BOOK2LEHMANN_SEAGRAPETREE_3P_MD from '@/components/Book2/Lehmann_SeaGrapeTree_3P_MD'
 import BOOK2LEHMANN_SEAGRAPETREE_3P_MD2 from '@/components/Book2/Lehmann_SeaGrapeTree_3P_MD2'
 import BOOK2LEHMANN_SEAGRAPETREE_3P_MD3 from '@/components/Book2/Lehmann_SeaGrapeTree_3P_MD3'
 import BOOK2LEHMANN_SEAGRAPETREE_3P_MD4 from '@/components/Book2/Lehmann_SeaGrapeTree_3P_MD4'
 import LOVE_2 from '@/components/love_2'
 import COMONAUTHOR from '@/components/Comon/author'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import COMONAUBA from '@/components/Comon/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/cover",
 			"name" : "Book1/cover",
 			"component" : BOOK1COVER
 		},
 		{
 			"path" : "/Book1/Lehmann_BalladSource_3P_MD",
 			"name" : "Book1/Lehmann_BalladSource_3P_MD",
 			"component" : BOOK1LEHMANN_BALLADSOURCE_3P_MD
 		},
 		{
 			"path" : "/Book1/Lehmann_BalladSource_3P_MD2",
 			"name" : "Book1/Lehmann_BalladSource_3P_MD2",
 			"component" : BOOK1LEHMANN_BALLADSOURCE_3P_MD2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js